import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";
import { CropMap } from "../shared/dtos/arcgis-map-crop-props.dto";
import { ICropAggregationDto } from "../shared/dtos/crop-aggregation.dto";
import { IFarmDto } from "../shared/dtos/farm.dto";
import { IFarmNameTuple } from "../shared/interfaces/farm-name-tuple";
import { FarmNameTuple } from "../shared/models/farm-name-tuple";

function toFarmNameTuples(dtos: IFarmDto[]): IFarmNameTuple[] {
  return dtos
    .map(
      (farmDto: IFarmDto) =>
        new FarmNameTuple({
          id: farmDto.id,
          nameArcgis: farmDto.name,
          nameEkocrop: farmDto.name,
        })
    )
    .sort((prev: IFarmNameTuple, next: IFarmNameTuple) =>
      prev.nameEkocrop.localeCompare(next.nameEkocrop)
    );
}

export const mapPageApi = createApi({
  reducerPath: "mapPageApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchFarmLandGeometries: builder.query<CropMap, { farmId: string; seasonId: string }>(
      {
        query: ({ farmId, seasonId }) => ({
          url: "FarmLands/GetFarmLandGeometries",
          params: { farmId, seasonId, withGeometryForSwaggerFalse: "true" },
        }),
      }
    ),

    fetchAvailableFarms: builder.query<IFarmNameTuple[], string>({
      queryFn: pagedQueryFn<IFarmDto, IFarmNameTuple[], string>(
        (userId) => ({ url: `AppUsersV2/${userId}/farms` }),
        toFarmNameTuples
      ),
    }),

    fetchCropAggregation: builder.query<
      ICropAggregationDto[],
      { farmId: string; seasonName: string }
    >({
      query: ({ farmId, seasonName }) => ({
        url: `FarmsV2/${farmId}/cropAggregation`,
        params: { seasonName },
      }),
    }),
  }),
});

export const {
  useFetchFarmLandGeometriesQuery,
  useFetchAvailableFarmsQuery,
  useFetchCropAggregationQuery,
} = mapPageApi;
export const mapPageApiReducer = mapPageApi.reducer;
